import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=7a478e1f&"
import script from "./RegionPicker.vue?vue&type=script&lang=js&"
export * from "./RegionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a478e1f')) {
      api.createRecord('7a478e1f', component.options)
    } else {
      api.reload('7a478e1f', component.options)
    }
    module.hot.accept("./RegionPicker.vue?vue&type=template&id=7a478e1f&", function () {
      api.rerender('7a478e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/RegionPicker.vue"
export default component.exports